import { AccessTypes } from '../const/accessRole';
import { getPermissions } from './getPermissions.helper';

/**
 * Get sidebar permissions for a specific module/sideBarId
 * Can be used in components to check permissions in HTML templates
 * @param profileData - The profile data from AuthService (UserData)
 * @param sideBarId - The sideBarId from ModuleConst to check permissions for
 * @returns AccessTypes object with isView, isAdd, isEdit, isDelete permissions
 */
export function getSidebarPermissions(
  profileData: any,
  sideBarId: number
): AccessTypes {
  const adminRole = 5;
  const subAdminRole = 9;

  if (profileData?.role === adminRole) {
    return {
      isAdd: true,
      isDelete: true,
      isEdit: true,
      isView: true
    };
  }

  const permissions = getPermissions(profileData);

  const permission = permissions.find((perm: any) => perm.sideBarId === sideBarId);

  if (permission) {
    return {
      isAdd: permission.isAdd || false,
      isDelete: permission.isDelete || false,
      isEdit: permission.isEdit || false,
      isView: permission.isView || false
    };
  }

  return {
    isAdd: false,
    isDelete: false,
    isEdit: false,
    isView: false
  };
}
